import React from 'react';
import { useTheme } from '../../../hooks/useTheme';
import { Stack } from '../../stack';
import { AudioPlayerCSSTokens, AudioPlayerOwnerState } from '../model';

const lines1 = [
  { id: 1, x1: 113.399, x2: 113.399, y1: 13.65, y2: 21.0653 },
  { id: 2, x1: 81.6695, x2: 81.6695, y1: 13.65, y2: 21.0653 },
  { id: 3, x1: 85.6357, x2: 85.6357, y1: 10.6668, y2: 24.0489 },
  { id: 4, x1: 89.6018, x2: 89.6018, y1: 8.80197, y2: 25.9132 },
  { id: 5, x1: 93.568, x2: 93.568, y1: 3.95383, y2: 30.761 },
  { id: 6, x1: 97.5342, x2: 97.5341, y1: 6.56333, y2: 28.5225 },
  { id: 7, x1: 100.5342, x2: 100.5341, y1: 4.56333, y2: 24.5225 },
  { id: 8, x1: 101.5, x2: 101.5, y1: 10.6668, y2: 27.7781 },
  { id: 9, x1: 61.3979, x2: 61.3979, y1: 6.56333, y2: 28.5225 },
  { id: 10, x1: 105.467, x2: 105.467, y1: 3.95383, y2: 30.761 },
  { id: 11, x1: 65.364, x2: 65.364, y1: 4.69943, y2: 28.5232 },
  { id: 12, x1: 109.433, x2: 109.433, y1: 8.80197, y2: 25.9132 },
  { id: 13, x1: 69.3302, x2: 69.3302, y1: 12.5317, y2: 22.5575 },
  { id: 14, x1: 1.95383, x2: 1.95383, y1: 13.65, y2: 21.0653 },
  { id: 15, x1: 45.0154, x2: 45.0154, y1: 14.7689, y2: 20.3196 },
  { id: 16, x1: 5.86881, x2: 5.86881, y1: 10.6668, y2: 24.0489 },
  { id: 17, x1: 9.78342, x2: 9.78342, y1: 8.80197, y2: 25.9132 },
  { id: 18, x1: 49.5828, x2: 49.5828, y1: 12.5317, y2: 22.1846 },
  { id: 19, x1: 13.6984, x2: 13.6984, y1: 3.95383, y2: 30.761 },
  { id: 20, x1: 109.433, x2: 109.433, y1: 8.80197, y2: 25.9132 },
];

const lines2 = [
  { id: 21, x1: 17.6128, x2: 17.6128, y1: 6.56333, y2: 28.5225 },
  { id: 22, x1: 57.4125, x2: 57.4125, y1: 8.80197, y2: 25.9132 },
  { id: 23, x1: 21.5273, x2: 21.5273, y1: 10.6668, y2: 27.7781 },
  { id: 24, x1: 25.7683, x2: 25.7683, y1: 3.95383, y2: 30.761 },
  { id: 25, x1: 29.6834, x2: 29.6834, y1: 8.80197, y2: 25.9132 },
  { id: 26, x1: 33.5984, x2: 33.5984, y1: 3.95383, y2: 30.761 },
  { id: 27, x1: 37.5122, x2: 37.5122, y1: 12.5317, y2: 22.1846 },
  { id: 28, x1: 41.1008, x2: 41.1008, y1: 11.0387, y2: 23.6749 },
  { id: 29, x1: 73.2965, x2: 73.2965, y1: 11.7851, y2: 24.4213 },
  { id: 30, x1: 73.2965, x2: 73.2965, y1: 11.7851, y2: 24.4213 },
  { id: 31, x1: 189.105, x2: 189.105, y1: 13.6501, y2: 21.0654 },
  { id: 32, x1: 172.843, x2: 172.843, y1: 6.56333, y2: 28.5225 },
  { id: 33, x1: 176.809, x2: 176.809, y1: 4.69943, y2: 28.5232 },
  { id: 34, x1: 180.775, x2: 180.775, y1: 12.5317, y2: 22.5575 },
  { id: 35, x1: 113.399, x2: 113.399, y1: 13.65, y2: 21.0653 },
  { id: 36, x1: 156.461, x2: 156.461, y1: 14.7689, y2: 20.3196 },
  { id: 37, x1: 117.314, x2: 117.314, y1: 10.6668, y2: 24.0489 },
  { id: 38, x1: 121.229, x2: 121.229, y1: 8.80197, y2: 25.9132 },
  { id: 39, x1: 161.028, x2: 161.028, y1: 12.5317, y2: 22.1846 },
  { id: 40, x1: 125.144, x2: 125.144, y1: 3.95383, y2: 30.761 },
  { id: 41, x1: 164.943, x2: 164.943, y1: 3.95383, y2: 30.761 },
  { id: 42, x1: 129.058, x2: 129.058, y1: 6.56333, y2: 28.5225 },
  { id: 43, x1: 168.858, x2: 168.858, y1: 8.80197, y2: 25.9132 },
  { id: 44, x1: 132.973, x2: 132.973, y1: 10.6668, y2: 27.7781 },
  { id: 45, x1: 137.214, x2: 137.214, y1: 3.95383, y2: 30.761 },
  { id: 46, x1: 141.129, x2: 141.129, y1: 8.80197, y2: 25.9132 },
  { id: 47, x1: 145.044, x2: 145.044, y1: 3.95383, y2: 30.761 },
  { id: 48, x1: 148.958, x2: 148.958, y1: 12.5317, y2: 22.1846 },
  { id: 49, x1: 152.546, x2: 152.546, y1: 11.0387, y2: 23.6749 },
  { id: 50, x1: 184.742, x2: 184.742, y1: 11.7851, y2: 24.4213 },
];

interface AudioPlayerTrackProps {
  ownerState: AudioPlayerOwnerState;
  progress: number;
}

export const AudioPlayerTrack = ({ ownerState, progress }: AudioPlayerTrackProps) => {
  const { size } = ownerState;
  const theme = useTheme();

  const linesList = size === 'small' ? lines1 : [...lines1, ...lines2];
  const containerWidth = size === 'small' ? 108 : 192;

  const normalizedLines = linesList.map((line) => ({
    id: line.id,
    height: line.y2 - line.y1,
    centerY: (line.y1 + line.y2) / 2,
  }));

  const step = containerWidth / (normalizedLines.length + 1);
  const lines = normalizedLines.map((line, i) => ({
    id: line.id,
    x1: step * (i + 1),
    x2: step * (i + 1),
    y1: line.centerY - line.height / 2,
    y2: line.centerY + line.height / 2,
  }));

  return (
    <Stack
      alignItems="center"
      className="audio-player-track"
      direction="row"
      sx={{
        ml: { normal: 1.5, small: 1 }[size],
        overflow: 'hidden',
        width: containerWidth,
      }}
    >
      <svg
        fill="none"
        height="34"
        style={{
          display: 'flex',
          flex: `0 0 ${containerWidth}px`,
          transition: 'stroke 0.3s ease',
        }}
        viewBox={`0 0 ${containerWidth} 34`}
        width={containerWidth}
        xmlns="http://www.w3.org/2000/svg"
      >
        {lines.map((line) => {
          const linePosition = (line.x1 / containerWidth) * 100;
          const isFilled = progress >= linePosition;
          return (
            <line
              key={line.id}
              stroke={isFilled ? theme.palette['brand pink'] : AudioPlayerCSSTokens.TrackColor(theme.palette['gray middle'])}
              strokeLinecap="round"
              strokeWidth="1.90766"
              x1={line.x1}
              x2={line.x2}
              y1={line.y1}
              y2={line.y2}
            />
          );
        })}
      </svg>
    </Stack>
  );
};
